import { useEffect, useState } from "react";

/**
 * Phone breakpoint hook — the mirror of {@link useIsDesktop}. Both key off the
 * Tailwind `md` boundary (768px) so "mobile" is exactly "not desktop" and the
 * `md` breakpoint stays the single source of truth for the shell.
 *
 * Use only where a JS boolean is needed (native pickers, sheet-vs-modal choice,
 * tap-tooltips, agenda-vs-grid). For pure layout, prefer Tailwind classes.
 */
const QUERY = "(max-width: 767px)";

export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState<boolean>(() => {
    if (typeof window === "undefined") return false;
    return window.matchMedia(QUERY).matches;
  });

  useEffect(() => {
    const mql = window.matchMedia(QUERY);
    const handler = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    mql.addEventListener("change", handler);
    return () => mql.removeEventListener("change", handler);
  }, []);

  return isMobile;
}
